import React from "react";

const RestaurantOwner = ({ handleJoinUs }) => (
  <div className="tab-info join-us">
    <h4>Join Our Local E Revolution!</h4>
    <p>
      Is your business looking for lower commission rates and a platform that
      champions local independent restaurants and takeaways? Then you’ve come to
      the right place. Click below to find out more and join the revolution.
    </p>
    <a
      href="javascript: void(0)"
      onClick={() => handleJoinUs({ status: "open" })}
      className="btn btn-blue"
    >
      Join us
    </a>
  </div>
);

export default RestaurantOwner;
